import $ from 'jquery'
import Util from '../../bootstrap/js/src/util'

/**
 * --------------------------------------------------------------------------
 * ActiveElements (v1.0.0): contactcontactmap.js
 * --------------------------------------------------------------------------
 */

const ContactMap = (($) => {


  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  const NAME                = 'contactmap'
  const VERSION             = '1.0.0'
  const DATA_KEY            = 'ae.contactmap'
  const EVENT_KEY           = `.${DATA_KEY}`
  const DATA_API_KEY        = '.data-api'
  const JQUERY_NO_CONFLICT  = $.fn[NAME]

  const Default = {
    color: '#DCDCDA',
    hoverColor: '#ff0000',
    offset: 0,
    speed: 500,
    delay: 0,
    hideChildCollapse: true,
    hideClass: 'd-none'
  }

  const DefaultType = {
    color: 'string',
    hoverColor: 'string',
    offset: 'number',
    speed: 'number',
    delay: 'number',
    hideChildCollapse: 'bool',
    hideClass: 'string'
  }

  const Selector = {
    CONTACTMAP : '[data-plugin="contactmap"]',
    CONTINENTS : 'svg [data-element="continent"]',
    POINTS: 'path[data-element!="ignore"], circle[data-element!="ignore"]',
    LABELS: '[data-element="label"]',
    INFOPOINTS: '.info-point'
  }

  const Event = {
    LOAD_DATA_API : `load${EVENT_KEY}${DATA_API_KEY}`,
    CLICK_DATA_API : `click${EVENT_KEY}${DATA_API_KEY}`
  }

  /*
  const ClassName = {
  }
  */

  /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */

  class ContactMap {

    constructor(element, config) {
      const _self   = this
      this._element = element
      this._config  = this._getConfig( config )

      this._initContinents()

      this._initInfoPoints()
    }

    // getters

    static get VERSION() {
      return VERSION
    }

    static get Default() {
      return Default
    }

    // public

    // private
    _initInfoPoints() {
      const _self = this
      const infoPoints = this._getInfoPoints()

      infoPoints.each( function( index, point ) {
        let boxId = $( point ).data( 'box' )

        // hide box at click at open box (if not anchor was clicked)
        $( boxId ).on( 'click', function( event ) {
          if( !$( event.target ).is( 'a' ) ) {
            $( this ).addClass( _self._config.hideClass )
          }
        })

        // show box at click at point
        $( point ).on( 'click', function() {
          let $point = $( this )
          let boxId = $point.data( 'box' )

          _self._hideInfoBoxes()

          $( boxId ).removeClass( _self._config.hideClass )
        });
      })
    }

    _hideInfoBoxes() {
      const _self = this
      const infoPoints = this._getInfoPoints()

      infoPoints.each( function( index, point ) {
        let boxId = $( point ).data( 'box' )

        $( boxId ).addClass( _self._config.hideClass )
      })
    }

    _getInfoPoints() {
      return $( this._element ).find( Selector.INFOPOINTS )
    }

    _initContinents() {
      const _self   = this
      const element = _self._element
      const config  = _self._config

      this.continents = $( element ).find( Selector.CONTINENTS )
      this.labels = $( element ).find( Selector.LABELS )

      this.continents.each(function( index, continent ) {
        let $continent = $( continent )

        $continent.find( Selector.POINTS ).attr( 'fill', config.color )

        $continent.on('click', function() {
          const $_continent = $( this )

          _self._continentClick( $_continent )
        });
        $continent.on('mouseenter', function() {
          const points = $(this).find( Selector.POINTS )

          _self._colorizePoints( points, _self._config.hoverColor )
        });

        $continent.on('mouseleave', function() {
          const points = $(this).find( Selector.POINTS )

          _self._colorizePoints( points, _self._config.color )
        });
      });
    }

    _continentClick( $continent ) {
      this._hideInfoBoxes()

      this._showContinent( $continent )
    }

    _showContinent( $continentToShow ) {
      const _self = this
      const $target = $( $continentToShow.data( 'target' ) )

      if( $target.length > 0 ) {
        if( $target.data( 'toggle' ) == 'collapse' ) {
          _self._updateContinents( $continentToShow )
        }

        setTimeout(
          function() {
            $([document.documentElement, document.body]).animate({
              scrollTop: $target.offset().top - _self._config.offset
            }, _self._config.speed);
          }, _self._config.delay
        )
      }
    }

    _updateContinents( $continentToShow ) {
      const _self = this
      const $target = $( $continentToShow.data( 'target' ) )
      const $collapse = $( $target.data( 'target' ) )

      this.continents.each(function( index, continent ) {
        const target = $( continent ).data( 'target' )

        if( target != $continentToShow.data( 'target' ) ) {
          const $target = $( target )
          const $collapse = $( $target.data( 'target' ) )

          if( $collapse.length > 0 ) {
            $collapse.collapse( 'hide' )

            if( _self._config.hideChildCollapse ) {
              _self._hideChildCollapses( $collapse )
            }
          }
        }
      })

      if( $collapse.length > 0 ) {
        $collapse.collapse( 'show' )
      }
    }

    _hideChildCollapses( $parent ) {
      const $buttons = $( $parent.find( '[data-toggle="collapse"]') )

      $buttons.each( function( index, button ) {
        let children = $parent.find( $(button).data('target') )

        $( children ).collapse('hide')
      })
    }

    _colorizePoints( points, color ) {
      points.attr( 'fill', color )
    }

    _getConfig(config) {
      config = $.extend({}, Default, config)
      Util.typeCheckConfig(NAME, config, DefaultType)
      return config
    }

    // static

    static _jQueryInterface(config) {
      return this.each(function () {
        const $element = $(this)
        const _config = typeof config === 'object' ? config : null

        let data       = $element.data(DATA_KEY)

        if (!data) {
          data = new ContactMap(this, _config)
          $element.data(DATA_KEY, data)
        }

        if (config === 'close') {
          data[config](this)
        }
      })
    }

  }


  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */

  $(window).on(Event.LOAD_DATA_API, () => {
    $(Selector.CONTACTMAP).each(function () {
      const $contactmap = $(this)
      ContactMap._jQueryInterface.call($contactmap, $contactmap.data())
    })
  })


  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */

  $.fn[NAME]             = ContactMap._jQueryInterface
  $.fn[NAME].Constructor = ContactMap
  $.fn[NAME].noConflict  = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT
    return ContactMap._jQueryInterface
  }

  return ContactMap

})($)

export default ContactMap
